import BaseSVG, { BaseSVGProps } from '../BaseSVG'

export const ImportIcon = (props: BaseSVGProps) => {
  return (
    <BaseSVG {...props} viewBox="0 0 16 16" stroke="black" fill="none">
      <g clipPath="url(#clip0_1104_7737)">
        <path d="M5.99927 5.00067L7.99927 7.00068L9.99927 5.00067" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.99927 7.00069V0.500671" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.99927 12.5007H3.49927" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.2493 12.7507C10.1112 12.7507 9.99927 12.6387 9.99927 12.5007C9.99927 12.3626 10.1112 12.2507 10.2493 12.2507" />
        <path d="M10.2493 12.7507C10.3873 12.7507 10.4993 12.6387 10.4993 12.5007C10.4993 12.3626 10.3873 12.2507 10.2493 12.2507" />
        <path d="M12.7493 12.7507C12.6112 12.7507 12.4993 12.6387 12.4993 12.5007C12.4993 12.3626 12.6112 12.2507 12.7493 12.2507" />
        <path d="M12.7493 12.7507C12.8873 12.7507 12.9993 12.6387 12.9993 12.5007C12.9993 12.3626 12.8873 12.2507 12.7493 12.2507" />
        <path
          d="M12.4993 15.5007H3.49927C2.70362 15.5007 1.94056 15.1846 1.37795 14.622C0.815339 14.0593 0.499268 13.2963 0.499268 12.5007C0.499268 11.705 0.815339 10.9419 1.37795 10.3793C1.94056 9.81674 2.70362 9.50067 3.49927 9.50067H12.4993C13.2949 9.50067 14.058 9.81674 14.6206 10.3793C15.1832 10.9419 15.4993 11.705 15.4993 12.5007C15.4993 13.2963 15.1832 14.0593 14.6206 14.622C14.058 15.1846 13.2949 15.5007 12.4993 15.5007Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1104_7737">
          <rect width={props.width ?? 16} height={props.height ?? 16} fill="white" />
        </clipPath>
      </defs>
    </BaseSVG>
  )
}
